<template>
  <div>
    <title-bar title="模拟通讯">
      <el-button type="primary" @click="startSend()" :disabled="this.running">开始</el-button>
      <el-button type="primary" @click="stopSend()" :disabled="!this.running">暂停</el-button>
    </title-bar>
    <div class="page-body">
      <el-form :model="status" label-width="90px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="设备编码" prop="deviceCode">
              <el-input type="text" v-model="status.deviceCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="室内温度" prop="inTemp">
              <el-input-number v-model="status.inTemp"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="室外温度" prop="outTemp">
              <el-input-number v-model="status.outTemp"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="室内湿度" prop="inWet">
              <el-input-number v-model="status.inWet"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="室外湿度" prop="outWet">
              <el-input-number v-model="status.outWet"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="PM2.5" prop="pm">
              <el-input-number v-model="status.pm"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="无纺布剩余更换次数" prop="clothLeftCount">
              <el-input-number v-model="status.clothLeftCount"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="新风运行" prop="fanState">
              <el-switch v-model="status.fanState" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="空调运行" prop="acState">
              <el-switch v-model="status.acState" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传感器异常" prop="errorSensor">
              <el-switch v-model="status.errorSensor"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="空调异常" prop="errAc">
              <el-switch v-model="status.errAc"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高温告警" prop="highTemp">
              <el-switch v-model="status.highTemp"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电表离线" prop="errKwh">
              <el-switch v-model="status.errKwh"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <div v-for="msg in messages">
          {{msg}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TitleBar from "@/components/base/TitleBar.vue";
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  components: {TitleBar},

  data() {
    return {
      running: false,
      it: null,
      status: {
        deviceCode: "GY-201912-00004",
        fanState: 1,
        acState: 1,
        inTemp: 25,
        outTemp: 28,
        inWet: 55,
        outWet: 67,
        pm: 12,
        clothLeftCount: 30,
        errorSensor: false,
        errAc: false,
        errFire: false,
        errKwh: false
      },
      socket: null,
      messages: [],
    }
  },

  created() {
    console.log(this.globalConfig.wsRoot+"/status-receive");
    this.socket = new WebSocket(this.globalConfig.wsRoot+"/status-receive");
    //打开事件
    this.socket.onopen = () => {
      this.messages.push("连接成功！");
    };
    //获得消息事件
    this.socket.onmessage = (msg) => {
      this.messages.push(msg.data);
    };
    //关闭事件
    this.socket.onclose = () => {
      this.messages.push("Socket已关闭!");
    };
    //发生了错误事件
    this.socket.onerror = (e) => {
      console.log(e);
      this.messages.push("连接失败！！！")
    }
  },

  beforeDestroy() {
    this.stopSend();
    if(this.socket) {
      this.socket.close();
    }
  },

  methods: {
    startSend() {
      this.running = true;
      this.send();
      this.it = setInterval(this.send,2000);
    },

    stopSend() {
      this.running = false;
      if(this.it) {
        clearInterval(this.it);
      }
    },

    send() {
      this.messages.push(JSON.stringify(this.status));
      this.socket.send(JSON.stringify(this.status));
    }
  }

}
</script>

<style scoped lang="scss">

</style>